import { Result, SharedVaultUserPermission } from '@standardnotes/domain-core';
export class IsReadonlyVaultMember {
    constructor(users, cache) {
        this.users = users;
        this.cache = cache;
    }
    execute(vault) {
        var _a;
        if (!vault.sharing) {
            return Result.ok(true);
        }
        if (!vault.sharing.ownerUserUuid) {
            throw new Error(`Shared vault ${vault.sharing.sharedVaultUuid} does not have an owner user uuid`);
        }
        const user = this.users.sureUser;
        const vaultUsers = this.cache.get(vault.sharing.sharedVaultUuid);
        const userPermission = (_a = vaultUsers === null || vaultUsers === void 0 ? void 0 : vaultUsers.find((vaultUser) => vaultUser.user_uuid === user.uuid)) === null || _a === void 0 ? void 0 : _a.permission;
        return Result.ok(userPermission === SharedVaultUserPermission.PERMISSIONS.Read);
    }
}
